import React, { Component } from "react";
import { connect } from "react-redux";
import { Row } from "simple-flexbox";
import { withRouter } from "react-router-dom";
import { getUser } from "../../helpers/user";
import ContentContainer from "../../components/container/ContainerComponent";
import MaterialTable from "material-table";
import { trainingList } from "../../actions/master-data/training_actions";
import {
    getTrainingListPending,
    getTrainingList,
    getTrainingListError,
} from "../../reducers/master-data/training_reducer";
import MenuItem from "@material-ui/core/MenuItem";
import DetailButtonComponent from "../../components/global-components/DetailButtonComponent";
import { TablePagination } from "@material-ui/core";
import { Paper } from "@material-ui/core";
import HeaderPelatihan from "./HeaderPelatihan";
import TableStatusComponent from "../../components/global-components/TableStatusComponent";
import ModalHapusPelatihan from "./Modal_delete_pelatihan";

class ListPelatihan extends Component {
    constructor(props) {
        super(props);
        this.tableRef = React.createRef();
        this.state = {
            search: "",
            status: "",
            modalEditPelatihanShow: false,
            modalDeletePelatihanShow: false,
            training_id: "",
            id: null,
        };
        this.handleRefresh = this.handleRefresh.bind(this);
    }

    handleRefresh(state) {
        this.setState(state);
        this.setState({ id: null })
        this.tableRef.current && this.tableRef.current.onQueryChange();
    }

    handleDetailPelatihan(id) {
        this.props.history.push(`/training/detail/${id}`)
    }

    handleDeletePelatihan(data) {
        const param_listPelatihan = {
            id: data.id
        };

        const callback = () => {
            this.setState({ training_id: data.id });
            this.setState({ modalHapusPelatihanShow: true });
            this.handleRefresh();
        }
        this.props.universityList(param_listPelatihan, callback);
    }

    componentDidMount() {
        if (this.props.match.params.id && this.state.id === null) {
            this.setState({ id: this.props.match.params.id })
        }
    }

    render() {
        const { trainingList, trainingList_data } = this.props;
        const { modalHapusPelatihanShow } = this.state;
        let data = [];
        let records_total = "";
        let length = "";
        if (trainingList_data) {
            data = trainingList_data;
            records_total = data.records_total;
            length = data.data.length;
        }
        return (
            <ContentContainer>
                <ModalHapusPelatihan
                    show={modalHapusPelatihanShow}
                    onHide={() => this.setState({ modalHapusPelatihanShow: false })}
                    data={data}
                    handleRefresh={this.handleRefresh}
                />
                <HeaderPelatihan handleRefresh={this.handleRefresh} />
                <MaterialTable
                    tableRef={this.tableRef}
                    title="Pelatihan"
                    columns={[
                        {
                            title: "No", field: "name",
                            render: (rowData) => {
                                return <>{rowData.no}</>
                            },
                            width: 20,
                            headerStyle: {
                                paddingLeft: 40,
                            },
                            cellStyle: {
                                paddingLeft: 40,
                            },
                        },
                        { title: "Nama Institusi", field: "institution" },
                        { title: "Nama Pelatihan", field: "name" },
                        { title: "Tahun", field: "year" },
                        {
                            title: "Status",
                            field: "status",
                            render: ({ status }) => {
                                return (
                                    <TableStatusComponent
                                        status={status === 0 ? "Baru" : status === 1 ? "Terverifikasi" : "Ditolak"}
                                    />
                                );
                            },
                        },
                        {
                            title: "",
                            render: (data) => {
                                return (
                                    <DetailButtonComponent>
                                        <MenuItem onClick={() => this.handleDetailPelatihan(data.id)}>
                                            Detail
                                        </MenuItem>
                                        {/* <MenuItem onClick={() => this.handleDeletePelatihan(data.id)}>
                                            Delete
                                        </MenuItem> */}
                                    </DetailButtonComponent>
                                );
                            },
                        },
                    ]}
                    data={(query) =>
                        new Promise((resolve, reject) => {
                            let param = {
                                page: query.page + 1,
                                length: 10,
                                search_text: this.state.search,
                                id: this.state.id,
                                user_id: getUser().id,
                                status: this.state.status
                            };
                            trainingList(param, resolve, reject);
                        })
                    }
                    options={{
                        paginationType: "stepped",
                        pageSize: 10,
                        pageSizeOptions: [],
                        showTitle: false,
                        search: false,
                        headerStyle: {
                            backgroundColor: "#F8F9FB",
                        },
                    }}
                    components={{
                        Toolbar: () => <div />,
                        Container: (props) => <Paper {...props} elevation={0} />,
                        Pagination: (props) => (
                            <Row
                                // vertical="center"
                                horizontal="space-between"
                                style={{ paddingRight: 20, paddingLeft: 20 }}
                            >
                                <Row
                                    style={{
                                        // backgroundColor: "red",
                                        width: "50%",
                                        borderBottom: "1px solid rgba(224, 224, 224)",
                                    }}
                                    vertical="center"
                                >
                                    <p> Menampilkan {length} dari {records_total} data </p>
                                </Row>
                                <TablePagination
                                    {...props}
                                    color="primary"
                                    labelRowsPerPage={
                                        <div style={{ fontSize: 14 }}>{props.labelRowsPerPage}</div>
                                    }
                                    labelDisplayedRows={(row) => (
                                        <div style={{ fontSize: 14, color: "red" }}>
                                            {props.labelDisplayedRows(row)}
                                        </div>
                                    )}
                                    SelectProps={{
                                        style: {
                                            fontSize: 20,
                                        },
                                    }}
                                />
                            </Row>
                        ),
                    }}
                />
            </ContentContainer>
        );
    }
}

function mapStateToProps({ trainingList }) {
    return {
        trainingList_pending: getTrainingListPending(trainingList),
        trainingList_data: getTrainingList(trainingList),
        trainingList_error: getTrainingListError(trainingList)
    };
}

export default connect(mapStateToProps, { trainingList })(withRouter(ListPelatihan));